import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder';
import { fg } from '@atlassian/jira-feature-gating';
import { AsyncFloatingSoftphoneCallBar } from './AsyncFloatingSoftphoneCallBar.tsx';
import { useIsEligibleForLiveConversationsActivityStatus } from './useIsEligibleForLiveConversationsActivityStatus.tsx';

const Inner = () => {
	const isEligible = useIsEligibleForLiveConversationsActivityStatus();

	if (!isEligible) {
		return null;
	}

	// Async keeps the heavy twilio flex sdk off the main bundle; the bar self-gates on call status.
	return (
		<Placeholder name="floating-softphone-call-bar" fallback={null}>
			<AsyncFloatingSoftphoneCallBar />
		</Placeholder>
	);
};

// Rendered on a persistent top-nav surface so the call bar survives narrow-viewport avatar hiding
// and CSM SPA navigation, instead of unmounting with the availability indicator.
export const SoftphoneCallBarHost = (): React.JSX.Element | null => {
	if (!fg('csm_omnichannel_native_voice')) {
		return null;
	}

	return (
		<JSErrorBoundary
			id="SoftphoneCallBarHost"
			packageName="jiraCustomerServiceLiveConversationsActivityStatus"
			teamName="boysenberry"
			fallback="unmount"
			sendToPrivacyUnsafeSplunk
		>
			<Inner />
		</JSErrorBoundary>
	);
};
